// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"Competitions__titleContainer___3n76W","title":"Competitions__title___3RJxq","subtitle":"Competitions__subtitle___1RF96","parent":"Competitions__parent___1v5MK"};